(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};
	var util = search.util = search.util || {};

	function retrieveKeymatchesFromSuggestions(keymatchProcessor) {
		var running;
		function abortRunning() {
			if(running) {
				running.abort();
			}
		}
		return function keymatchRetriever(data, configuration, callback) {
			abortRunning();

			// Build search string for keymatch from the suggestions we got
			var results = data.results || [];
			var query = '';
			for(var i=0;i<results.length;i+=1) {
				query += results[i].name + ' ';
			}
			if(query) {
				query = query.slice(0, -1);
			} else {
				// No autosuggest results, use the original query for keymatches
				query = configuration.query;
			}

			var autosuggestProcessor = this.processor;

			// Unregister after the first result form the autosuggest processor and abort
			// the current loading of keymatches if the autosuggest was aborted
			autosuggestProcessor.responder(util.respondOnce(['abort', 'data'], util.respondTo({
				abort: abortRunning
			})));

			function keymatchQueryDone(event, keymatchProcessor, data, config) {
				running = null;
				if(event === 'data') {
					autosuggestProcessor.send('keymatch-data', data, config);
				}
			}

			keymatchProcessor.responder(util.respondOnce(['data', 'error', 'abort'], keymatchQueryDone));
			keymatchProcessor.process({query: query, userQuery: configuration.query});
			running = keymatchProcessor;

			// FIXME: Should we wait with processing suggestions until keymatches are loaded?
			callback();
		};
	}

	function abortShortQueries(limit) {
		limit = limit || 3;
		return function shortQueriesAborter(configuration, callback) {
			if(String(configuration.query).length >= limit) {
				// All OK
				return callback();
			}
			this.abort();
			callback();
		};
	}

	function setUp(processor, keymatchRetriever, shortQueriesAborter) {
		if(keymatchRetriever) {
			processor.usePost(keymatchRetriever, 200);
		}
		processor.usePre(shortQueriesAborter||abortShortQueries(), -10000);
	}

	var plugins = search.plugins = search.plugins || {};
	var autosuggest = plugins.autosuggest = plugins.autosuggest || {};

	autosuggest.retrieveKeymatchesFromSuggestions = retrieveKeymatchesFromSuggestions;
	autosuggest.setUp = setUp;

})(window.SCS = window.SCS || {});


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/autosuggest.js
// module id = 42
// module chunks = 0